import React, { Component, Suspense, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';

// Per collegare il reducer - redux
import { connect } from 'react-redux';
// importa le actions del reducer
import * as actions from './reducers/actions/Auth';
import * as actionsDB from './reducers/actions/Database';

import SignIn from './components/Signin';
import SignOut from './components/SignOut';
import Navbar from './components/AdminPanel/Navbar';

import { Spinner } from 'react-bootstrap';
import NotFound from './components/NotFound';
import PrivacyPolicy from './components/Privacy/Privacy';
import Imprint from './components/Imprint/Imprint';
import Terms from './components/Terms/Terms';
import Support from './components/Support/Support';

// Load Components
const Wallpapers = React.lazy(() => import('./components/AdminPanel/Wallpapers/Wallpapers'));
const SearchComponent = React.lazy(() => import('./components/AdminPanel/SearchComponent/SearchComponent'));
const AdminPanel = React.lazy(() => import('./components/AdminPanel/AdminPanel')); // Importa il componente in maniera lazy, quindi solo quando viene veramente richiesto ed utilizzato
// import AdminPanel from './components/AdminPanel'; 

class App extends Component {

  componentDidMount() {
    // Al montaggio del componente principale verificare se l'utente è già loggato
    // console.log("[APP DidMount] - Prova ad effettuare l'autoLogin se il token è valido");

    // REDUX - mapActionToProps 
    this.props.onTryAutoSignUp(); // Quando il componente viene caricato allora prova ad effettuare il login con i dati salvati!, chiama la funzione presente nel reducer
    if (this.props.isAuthenticated) {
      this.props.autoLoadDataFirebase(); // chiama la funzione del redux
    }
  }

  // Navigation bar handler selected
  handleSelect = (e) => {
    this.setState({
      navbar: { linkSelected: e.target.id }
    })
  }

  render() {

    let navbar = null;
    if (this.props.isAuthenticated) {
      navbar = <Navbar title="Wallpapers Admin" actionLogout={this.props.onLogout} />
    }
    
    return (
      <Fragment>
        { navbar }
        <Switch>
          <Route exact path='/' component={SignIn} />
          <Route exact path="/admin" render={() => <Suspense fallback={<Spinner animation="grow" />}> <AdminPanel selectedTab="1" /></Suspense>} />
          <Route exact path="/search" render={() => <Suspense fallback={<Spinner animation="grow" />}> <SearchComponent /> </Suspense>} />
          <Route exact path="/wallpapers" render={() => <Suspense fallback={<Spinner animation="grow" />}> <Wallpapers /> </Suspense>} />
          <Route exact path="/signout" component={SignOut} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/imprint" component={Imprint} />
          <Route exact path="/terms-conditions" component={Terms} />
          <Route exact path="/support" component={Support} />
          <Route component={NotFound} />
        </Switch>
      </Fragment>
    );
  }

}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null // verifica quindi se l'utente è autenticato, ed effettua il rendering della route logout solo se questo è autenticato
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignUp: () => dispatch(actions.authCheckState()), // importa quindi la funzione di autoLogin dal redux action
    onLogout: () => dispatch(actions.logout()), // chiama la funzione logout dall reducer Auth,
    autoLoadDataFirebase: () => dispatch(actionsDB.readDataFromDB()) // load data from Firebase DB
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
